import {
  Component,
  computed,
  Input,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import { ModalService } from '@core/services';
import {
  buttonConfig,
  customComponentListener,
  modalConfig,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { CustomButtonComponent } from '../button/button.component';
import { bootstrapXLg } from '@ng-icons/bootstrap-icons';
import { NgComponentOutlet } from '@angular/common';
import { IconsComponent } from '../icons/icon.component';
import { spinnerSvgIcon } from 'src/assets/icons/icons';

@Component({
  standalone: true,
  templateUrl: './modal.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal.component.scss'],
  imports: [
    TranslateModule,
    CustomButtonComponent,
    NgComponentOutlet,
    IconsComponent,
  ],
})
export class CustomModalComponent {
  @Input({ required: true }) modal!: any;
  @Input({ required: true }) config!: Signal<any>;
  @Input({ required: false }) listeners!: customComponentListener[];

  private hideCloseBtn = false

  //modal types
  // confirmation --done
  // custom / just can customize body and can hide header and footer
  // Progress
  // info

  protected defaultConfig = {
    confirmation: {
      type: 'confirmation',
      title: 'modal.confirmation.title',
      description: 'modal.confirmation.description',
      size: 'md',
      actions: {
        cancel: {
          type: 'button',
          label: { key: 'modal.confirmation.cancel' },
          theme: 'light',
          color: 'tertiary',
          action: () => {
            this.modalService.dismiss(this.modal);
          },
        } as buttonConfig,
      },
    } as modalConfig,
  };

  protected icons = {
    x: bootstrapXLg,
    spinner: spinnerSvgIcon,
  };

  protected configs = computed(() => ({
    btn: {
      close: {
        type: 'icon',
        icon: this.icons.x,
        hidden: this.hideCloseBtn,
        theme: 'ghost',
        color: 'info',
        action: () => {
          this.modalService.dismiss(this.modal);
        },
      } as buttonConfig,
    },
  }));

  constructor(
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.hideCloseBtn = this.config().hideCloseBtn || false;
  }
}
